/**
 * Le nature, le cadenze e le durate che il Comune ha dichiarato per i propri
 * obblighi.
 *
 * Le leggono «Scadenze e allerte», il Cruscotto e «Documenti e cartelle» (la
 * durata dell'obbligo nel menu di caricamento), e devono leggerle allo stesso
 * modo, perche' e' da qui che dipende se i loro
 * numeri coincidono: un obbligo dichiarato «trimestrale» deve avere lo stesso
 * termine ovunque. Il caricamento stava copiato in ciascuna pagina.
 *
 * Senza un ente scelto non c'e' nulla da chiedere: il super admin e'
 * cross-ente, e lasciar decidere all'API quale ente servire sarebbe peggio che
 * non servirne nessuno.
 */

import { elencaRegole } from "../api/client";
import type { RegolaObbligo } from "../api/types";
import { useRisorsa } from "./useRisorsa";
import type { StatoRisorsa } from "./useRisorsa";

export function useRegole(enteId: number | null): StatoRisorsa<RegolaObbligo[]> {
  return useRisorsa<RegolaObbligo[]>(
    (segnale) => (enteId === null ? Promise.resolve([]) : elencaRegole(enteId, segnale)),
    [enteId],
  );
}
